/**
 * <s-maps-link>
 * Keeps an "Open in Google Maps" link in sync with the address typed into
 * the input inside it, so customers can check the address before sending.
 * No Google script is loaded; the link only opens Maps in a new tab.
 */
class MapsLink extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.link = this.querySelector('[data-maps-link]');
    if (!this.input || !this.link) return;
    this.update = this.update.bind(this);
    this.input.addEventListener('input', this.update);
    this.update();
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.update);
  }

  update() {
    const address = this.input.value.trim();
    this.link.hidden = address.length < 4;
    this.link.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  }
}

if (!customElements.get('s-maps-link')) {
  customElements.define('s-maps-link', MapsLink);
}
